<template>
  <div class="bg-cover bg-center h-screen relative">
    <BaseLayout>
      <InfoModal
        :model-value="showInfoModal"
        @update:model-value="toggleInfoModal"
      />
      <router-view />
      <EmailSubmitModal v-model="isEmailModalOpen" />
    </BaseLayout>
  </div>
</template>
<script setup lang="ts">
import BaseLayout from '@/layouts/BaseLayout.vue'
import { init } from '@/composables/reown.ts'
import { useWalletAuth } from '@/composables/wallet/use-wallet-auth.ts'
import { apiToken, hasTokenExpired, referrerCode } from '@/composables/auth.ts'
import { computed, onMounted } from 'vue'
import InfoModal from './components/info-modal/InfoModal.vue'
import { useLocalStorage } from '@vueuse/core'
import EmailSubmitModal from '@/components/EmailSubmitModal.vue'
import { useEmailModal } from '@/composables/use-email-modal'
import { LingoRouteName } from '@/router/routes.ts'
import { useRoute } from 'vue-router'

init()
const route = useRoute()
const isHome = computed(() => route.name === LingoRouteName.HOME)

const showInfoModal = useLocalStorage('show-info-modal', isHome.value)
const { logout } = useWalletAuth()
const { isEmailModalOpen } = useEmailModal()

onMounted(async () => {
  if (apiToken.value && hasTokenExpired()) {
    await logout()
  }
})

const toggleInfoModal = (val: boolean) => {
  showInfoModal.value = val
}

if (!referrerCode.value) {
  const urlParams = new URLSearchParams(window.location.search)
  const referrerCodeRef = urlParams.get('ref')
  if (referrerCodeRef) {
    referrerCode.value = referrerCodeRef
  }
}
</script>
